import { Component } from '@angular/core';
import { NavbarComponent } from "../../../../partials/navbar/navbar.component";
import { FooterComponent } from "../../../../partials/footer/footer.component";
import { LanguageService } from '../../../../services/language.service';

@Component({
  selector: 'app-why-is-it-better-to-use-ev-tires-for-ev',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './why-is-it-better-to-use-ev-tires-for-ev.component.html',
  styleUrl: './why-is-it-better-to-use-ev-tires-for-ev.component.css'
})
export class WhyIsItBetterToUseEvTiresForEvComponent {
  texts:any;
  back: any;

  constructor(private langServ: LanguageService) {
    this.texts = this.langServ.getWebisteTexts().posts.use_ev_tires;
    this.back = this.langServ.getWebisteTexts().posts.volver_text;
  }
}
